module.exports = __webpack_public_path__ + "static/img/fullscreen-image_consulting-services.9f6e8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_consulting-services.png
// module id = Hjf+
// module chunks = 0